import { Controller } from "stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
  static targets = ["toggle", "bulkComplete"]
  static values = {
    enabled: Boolean
  }

  connect() {
  }

  toggle() {
    this.enabledValue = this.toggleTarget.checked

    if (this.enabledValue) {
      this.smallCelebration(this.toggleTarget)
    }
  }

  bulkCompleteCelebration(event) {
    this.largeCelebration()
    setTimeout(() => {}, 200)
  }

  // Small celebration (checkbox-level)
  smallCelebration(element) {
    const rect = element.getBoundingClientRect()

    const x = (rect.left + rect.width / 2) / window.innerWidth
    const y = (rect.top + rect.height / 2) / window.innerHeight

    confetti({
      particleCount: 20,
      spread: 40,
      startVelocity: 12,
      gravity: 1.2,
      ticks: 120,
      origin: { x, y }
    })
  }

  // full-page celebration
  largeCelebration() {
    const duration = 2000
    const end = Date.now() + duration

    const frame = () => {
      confetti({
        particleCount: 6,
        angle: 90,
        spread: 120,
        startVelocity: 45,
        gravity: 1.3,
        ticks: 300,
        origin: {
          x: Math.random(),
          y: Math.random() * 0.4
        }
      })

      if (Date.now() < end) {
        requestAnimationFrame(frame)
      }
    }

    frame()
  }
}
